import { log } from '@/utils/log';
import { ElMessage } from 'element-plus';

export default function (app: any) {
    app.directive('track', {
        mounted(el: any, binding: any) {
            const { arg } = binding;
            let trackEvent: any;

            if (arg === 'click') {
                // 定义点击事件处理函数
                trackEvent = () => {
                    // 获取埋点信息，可以根据需要修改
                    const eventData = {
                        ...(binding.value || {}), // 传递的参数
                    };

                    // 发送埋点数据
                    log('clickEvent', eventData);
                };
                // 绑定点击事件
                el.addEventListener('click', trackEvent);
                // 清理事件监听器
                el.ownEvent = trackEvent; // 保存事件处理函数以便解绑
            } else if (arg === 'stayTime') {
                let startTime = Date.now();
                const resetStartTime = () => {
                    startTime = Date.now();
                };

                trackEvent = () => {
                    // 获取埋点信息，可以根据需要修改
                    const eventData = {
                        // 停留时长
                        stt: String(Date.now() - startTime),
                    };
                    // 发送埋点数据
                    log(arg, eventData);
                };

                const onPageVisibility = () => {
                    // 页面显示状态改变时，移除延时器
                    if (document.visibilityState === 'visible') {
                        resetStartTime();
                    } else {
                        trackEvent();
                        resetStartTime();
                    }
                };

                // 存到本地
                // 绑定点击事件
                window.addEventListener('pageshow', resetStartTime);
                window.addEventListener('pagehide', trackEvent);

                document.addEventListener('visibilitychange', onPageVisibility);

                // 清理事件监听器
                el.ownEvent = trackEvent; // 保存事件处理函数以便解绑
            }
        },
        onUnmounted(el: any) {
            // 移除事件监听器
            if (el.ownEvent) {
                el.removeEventListener('click', el.ownEvent);
                delete el.ownEvent; // 清理引用
            }
        },
    });
    app.directive('focus', {
        // elementplus input自动获取焦点
        mounted(el: any, binding: any) {
            if (!el) return;
            if (el.className.indexOf('el-textarea') !== -1) {
                setTimeout(() => {
                    el.children[0].focus();
                }, 0);
            } else if (el.className.indexOf('el-input') !== -1) {
                setTimeout(() => {
                    el.children[0]?.children[0]?.focus();
                }, 0);
            }
        },
    });
    // value: [projectUser,projectManager,projsetManager,platformManager]
    app.directive('auth', {
        // 鉴权指令
        mounted(el: any, binding: any, vnode: any, prevVnode: any) {
            if (!el) return;
            const { arg } = binding;
            if (arg === 'disabled') {
                // 采用disabled方式禁用
                const arr = el.className.split(' ').filter((val: any) => {
                    return val !== 'el-button--primary';
                });
                el.className = arr.join(' ') + ' is-disabled el-button--info';
                el.disabled = true;
                el.addEventListener('click', async () => {
                    const disabled = el.getAttribute('disabled');
                    if (disabled) return false;
                });
            } else if (arg === 'hide') {
                el.remove();
            }
        },
    });

    // 鉴定数据创建人与当前登陆用户是否为同一用户
    app.directive('dataAuth', {
        mounted(el: any, binding: any, vnode: any, prevVnode: any) {
            if (!el) return;
            const { value } = binding;
            const { userInfo } = useStore('user');

            if (!value) {
                el.style.display = 'none';
            } else if (value && userInfo.value.id !== value) {
                el.remove();
            } else {
                el.style.display = 'block';
            }
        },
        updated(el: any, binding: any, vnode: any, prevVnode: any) {
            if (!el) return;
            const { value } = binding;
            const { userInfo } = useStore('user');
            if (!value) {
                el.style.display = 'none';
            } else if (value && userInfo.value.id !== value) {
                el.remove();
            } else {
                el.style.display = 'block';
            }
        },
    });
    app.directive('copy', {
        mounted(el: any, binding: any) {
            if (!el) return;
            el.onclick = () => copuFun(el, binding);
        },
        updated(el: any, binding: any) {
            if (!el) return;
            el.onclick = () => copuFun(el, binding);
        },
    });
    // 注册全局自定义指令 `v-lazy`
    app.directive('lazy', {
        mounted(el: any, binding: any) {
            const { duration = 0.8, name = 'deault' } = binding.value || {};
            console.log('binding.value', binding.value);
            // 创建一个Intersection Observer来观察目标元素
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (name === 'fade-up') {
                        el.style.opacity = 0;
                        el.style.transform = `translateY(45%)`;
                        el.style.transition = `opacity 1s, transform 0.5s`;
                    } else {
                        el.style.transform = 'translateY(15%) scale(0.8)';
                        el.style.transition = `all ${duration}s`;
                        el.style.opacity = 0;
                        el.style.filter = 'blur(50px)';
                    }

                    // 当元素进入视口时
                    if (entry.isIntersecting) {
                        if (name === 'fade-up') {
                            el.style.opacity = 1;
                            el.style.transform = `translateY(0)`;
                        } else {
                            // 设置元素的src属性
                            el.style.transform = 'translateY(0px) scale(1)';
                            el.style.opacity = 1;
                            el.style.filter = 'none';
                            el.src = binding.value;
                        }

                        // 观察完成后取消观察
                        observer.unobserve(el);
                    }
                },
                {
                    // 可以根据需要调整配置
                    threshold: 0.01,
                }
            );
            // 开始观察元素
            observer.observe(el);
        },
        updated(el: any, binding: any) {
            // 创建一个Intersection Observer来观察目标元素
            const observer = new IntersectionObserver(
                ([entry]) => {
                    // 当元素进入视口时
                    if (entry.isIntersecting) {
                        // 设置元素的src属性
                        el.src = binding.value;
                        // 观察完成后取消观察
                        // observer.unobserve(el);
                    }
                },
                {
                    // 可以根据需要调整配置
                    threshold: 0.1,
                }
            );
            // 开始观察元素
            observer.observe(el);
        },
    });
    app.directive('lazy-load', {
        updated(el: any, binding: any) {
            const { src, isLazy } = binding.value || {};
            if (el.src === src || el.src.includes(src)) {
                return;
            }
            if (!isLazy) {
                el.src = src;
                return;
            }
            const observer = new IntersectionObserver(
                ([entry]) => {
                    // 当元素进入视口时
                    if (entry.isIntersecting) {
                        // 设置元素的src属性
                        el.src = src;
                        // 观察完成后取消观察
                        observer.unobserve(el);
                    }
                },
                {
                    // 可以根据需要调整配置
                    threshold: 0.01,
                }
            );
            // 开始观察元素
            observer.observe(el);
        },
        mounted(el: any, binding: any) {
            const { src, isLazy = false } = binding.value || {};
            if (!isLazy) {
                el.src = src;
                return;
            }
            // 创建一个Intersection Observer来观察目标元素
            const observer = new IntersectionObserver(
                ([entry]) => {
                    // 当元素进入视口时
                    if (entry.isIntersecting) {
                        // 设置元素的src属性
                        el.src = src;
                        // 观察完成后取消观察
                        observer.unobserve(el);
                    }
                },
                {
                    // 可以根据需要调整配置
                    threshold: 0.01,
                }
            );
            // 开始观察元素
            observer.observe(el);
        },
    });
}
function copyToClipboard(textToCopy: string) {
    // navigator clipboard 需要https等安全上下文
    if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        return navigator.clipboard.writeText(textToCopy);
    } else {
        // 创建text area
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = 'absolute';
        textArea.style.opacity = '0';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // 执行复制命令并移除文本框
            document.execCommand('copy') ? res('') : rej();
            textArea.remove();
        });
    }
}
const copuFun = async (el: any, binding: any) => {
    const value = binding.value;
    let str = value;
    if (typeof value === 'object') {
        str = value.value[value.key];
    }
    if (!str) {
        el.remove();
        return;
    }
    const disabled = el.getAttribute('disabled');
    if (disabled === true) return;
    await copyToClipboard(str);
    binding.arg === 'hiddenMsg'
        ? ''
        : ElMessage({
              showClose: true,
              grouping: true,
              message: '已成功复制到您的粘贴板',
              type: 'success',
          });
};
